import { render, staticRenderFns } from "./listnew.vue?vue&type=template&id=2fa1b3de&scoped=true&"
import script from "./listnew.vue?vue&type=script&lang=js&"
export * from "./listnew.vue?vue&type=script&lang=js&"
import style0 from "./listnew.vue?vue&type=style&index=0&id=2fa1b3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1b3de",
  null
  
)

export default component.exports